import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M5.5 8.5L2 12L5.5 15.5L6.207 14.793L3.914 12.5H22V11.5H3.914L6.207 9.207L5.5 8.5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ThinLongLeft"
);
